import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayerNotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6440_222005)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z" }), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_6440_222005)",
			fill: "currentColor",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M7.875 4.125V3.1875H6.70312V2.71875H6.23438V3.1875H5.76562V2.71875H5.29688V3.1875H4.82812V2.71875H4.35938V3.1875H3.1875V7.68398C3.1875 8.04797 3.48352 8.34375 3.84727 8.34375H4.35938V8.6393C4.35938 8.99344 4.65258 9.28125 5.01305 9.28125H8.15883C8.5193 9.28125 8.8125 8.9932 8.8125 8.6393V4.125H7.875ZM3.65625 7.68398V3.65625H4.35938V4.125H4.82812V3.65625H5.29688V4.125H5.76562V3.65625H6.23438V4.125H6.70312V3.65625H7.40625V7.68398C7.40625 7.78922 7.32047 7.875 7.21523 7.875H3.84727C3.74203 7.875 3.65625 7.78922 3.65625 7.68398ZM8.34375 8.6393C8.34375 8.73469 8.26078 8.8125 8.15883 8.8125H5.01305C4.91086 8.8125 4.82812 8.73469 4.82812 8.6393V8.34375H7.21523C7.57922 8.34375 7.875 8.04773 7.875 7.68398V4.59375H8.34375V8.6393Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M6.93703 4.82812H4.12453V5.29688H6.93703V4.82812Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M6.93703 5.76562H4.12453V6.23438H6.93703V5.76562Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M6.93703 6.70312H4.12453V7.17188H6.93703V6.70312Z" })
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", {})]
});
export default SvgPlayerNotes;
